'use strict';

var testEnabled = false;

let productGenderMap = {
    1: 'Woman',
    2: 'Man',
    3: 'Girl',
    4: 'Boy',
    5: 'Unisex',
    6: 'Baby'
};

let brandsMapping = {
    'CALZEDONIA': 'clz',
    'INTIMISSIMI': 'int',
    'TEZENIS': 'tzn',
    'FALCONERI': 'flc',
    'SIGNORVINO': 'sgv',
    'ATELIER_EME': 'eme'
};

var ListType = {
    'listing': {
        'class': 'category',
        'value': 'listing',
        'associatedObject': '.search-results'
    },
    'wishlist': {
        'class': 'wishlist-container',
        'value': 'wishlist',
        'associatedObject': '.wishlistItemCards'
    },
    'search': {
        'class': 'search',
        'value': 'search',
        'associatedObject': '.search-results'
    },
    'completeYourLook': {
        'class': 'completeYourLook',
        'value': 'complete_your_look',
        'associatedObject': '.completeYourLookContainer'
    },
    'recentlyViewed': {
        'class': 'recentlyViewed',
        'value': 'recently_viewed',
        'associatedObject': '.recentlyViewedContainer'
    },
    'suggestedProducts': {
        'class': 'suggestedProducts',
        'value': 'suggested_products',
        'associatedObject': '.suggestedProductsContainer'
    },
    'filteredProducts': {
        'class': 'filteredProducts',
        'value': 'filter_applied',
        'associatedObject': '.filteredProducts'
    },
    'bestSellers': {
        'class': 'bestSellers',
        'value': 'best_sellers',
        'associatedObject': '.bestSellers'
    },
    'cmBestSellers': {
        'class': 'cmBestSellers',
        'value': 'best_sellers',
        'associatedObject': '.cm-bestsellerCarousel-carouselWrapper .cm-carouselCustom.js-plp-productGrid'
    },
    'sortDecreasing': {
        'class': 'sortDecreasing',
        'value': 'sorting_decreasing_price',
        'associatedObject': '.sortDecreasing'
    },
    'sortIncreasing': {
        'class': 'sortIncreasing',
        'value': 'sorting_increasing_price',
        'associatedObject': '.sortIncreasing'
    },
    'newArrivals': {
        'class': 'newArrivals',
        'value': 'new_arrivals',
        'associatedObject': '.newArrivals'
    },
    'cmNewArrivals': {
        'class': 'cmNewArrivals',
        'value': 'new_arrivals',
        'associatedObject': '.cm-productCarousel-cardWrp.cm-carouselCustom'
    },
    'completeYourLookMiniCart': {
        'class': 'completeYourLookMiniCart',
        'value': 'complete_your_look_minicart',
        'associatedObject': '.miniCartCrossSellContainer-carousel'
    },
    'js-suggestedForYou': {
        'class': 'js-suggestedForYou',
        'value': 'suggested_for_you',
        'associatedObject': '.js-slotCarousel_suggestedProducts-carousel'
    },
    'js-completeThePromo': {
        'class': 'completeThePromo',
        'value': 'complete_your_look',
        'associatedObject': '.js-completeThePromoContainer'
    },
    'js-youMayAlsoLike': {
        'class': 'js-youMayAlsoLike',
        'value': 'you_may_also_like',
        'associatedObject': '.js-youMayAlsoLikeContainer'
    },
    'js-orderAgain-carousel': {
        'class': 'orderAgainCarousel',
        'value': 'buy_it_again',
        'associatedObject': '.js-orderAgain-carousel'
    },
    'js-orderAgain-seeSimilar-modal_list_item': {
        'class': 'seeSimilar-modal',
        'value': 'similar_products',
        'associatedObject': '.js-orderAgain-seeSimilar-modal_list_item'
    },
    'js-analytics-order-details-page': {
        'class': 'orderDetailsPage',
        'value': 'buy_it_again',
        'associatedObject': '.js-analytics-order-details-page'
    },
    'js-analytics-orderAgain-page': {
        'class': 'orderAgainPage',
        'value': 'buy_it_again',
        'associatedObject': '.js-analytics-orderAgain-page'
    }
};

function getProductGender (product) {
    if (product.sapCategoryCode) {
        let categoryCode = product.sapCategoryCode;
        return productGenderMap[parseInt(categoryCode[categoryCode.length - 1])];
    }
    return '';
}

function insertParam (key, value) {
    key = encodeURI(key); value = encodeURI(value);

    var kvp = document.location.search.substr(1).split('&');

    var i = kvp.length; var x; while (i--) {
        x = kvp[i].split('=');

        if (x[0] === key) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

    // this will reload the page, it's likely better to store this until finished
    document.location.search = kvp.join('&');
}

function hasParam (key) {
    key = encodeURI(key);

    return document.location.search.substr(1).indexOf(key) !== -1;
}

function getSkuCodes (sku) {
    if (sku.length >= 13) {
        let style = sku.substring(0, 9).trim();
        let color = sku.substring(9, 13).trim();
        let size = sku.substring(13).trim().replace('~', '/');
        return { id: style, color: color, size: size };
    } else {
        let color = sku.split('_')[1];
        return { id: sku, color: color };
    }
}

function formatStringForAnalytics (str) {
    return ('' + str).split(' ').join('_').toLowerCase().replace(/-/g, '_');
}

function getCatalogProductId (sku) {
    if (sku === null || typeof sku === 'undefined') {
        return '';
    }
    return ('' + sku).replace('_color_', ' ');
}

function formatStringProductPropertyIfExists (product, property, avoidFormatting = false) {
    if (property in product) {
        if (property === 'item_sfcc') {
            product[property] = getCatalogProductId(product[property]);
        } else if (avoidFormatting) {
            product[property] = '' + product[property];
        } else {
            product[property] = formatStringForAnalytics(product[property]);
        }
    }
    return product;
}

/* function formatStringProductPricePropertyIfExists (product, property, avoidFormatting = false) {
    if (property in product) {
        if (avoidFormatting) {
            product[property] = '' + product[property];
        } else {
            product[property] = formatStringForAnalytics(product[property]);
        }
        if (product['discount'] && product['discount'] < 0) {
            product[property] = '0.00';
            product['discount'] = 0.00;
        }
    }
    return product;
} */

function formatStringProductSalePropertyIfExists (product, property, avoidFormatting = false) {
    if (property in product) {
        if (avoidFormatting) {
            product[property] = '' + product[property];
        } else {
            product[property] = formatStringForAnalytics(product[property]);
        }
        if (product['discount'] && parseFloat(product['discount'])) {
            product[property] = 'yes';
        }
    }
    return product;
}

function formatFloatProductPropertyIfExists (product, property) {
    if (property in product) {
        product[property] = (product[property] <= 0) ? 0.00 : parseFloat(product[property]);
    }
    return product;
}

function formatIntegerForAnalytics (value) {
    return parseInt(value);
}

function formatIntegerProductPropertyIfExists (product, property) {
    if (property in product) {
        product[property] = formatIntegerForAnalytics(product[property]);
    }
    return product;
}

function stringOrNotAvailable (s) {
    return (s !== null && typeof s !== 'undefined' && String(s)) || 'not_available';
}

function numberOrZero (n) {
    return parseFloat(n) || 0;
}

function getStringAnalyticsValueFromStorage (key) {
    return stringOrNotAvailable(window.sessionStorage.getItem(key));
}

function getNumberAnalyticsValueFromStorage (key) {
    return numberOrZero(window.sessionStorage.getItem(key));
}

function getFormatSkuForAnalytics (sku) {
    let id, color, size, formattedSku;
    if (sku.toLowerCase().indexOf('color') !== -1) { // variant group
        id = sku.split('_')[0].trim();
        color = sku.split('_')[2].trim();
        formattedSku = id + '_' + color;
    } else {
        if (sku.match('[^_]+_[^_]+_[^_]+')) {
            return sku.toUpperCase();
        }
        let skuComponents = getSkuCodes(sku);
        id = skuComponents.id;
        color = skuComponents.color;
        size = skuComponents.size;
        if (color && size) {
            formattedSku = id + '_' + color + '_' + size;
        } else { // master product
            formattedSku = id;
        }
    }
    return formattedSku.toUpperCase().replace(/_+/g, '_');
}

module.exports = {

    isTestEnabled () {
        return testEnabled;
    },

    getAvailableListTypes (listingItemsBaseClass) {
        let types = [];

        for (let key in ListType) {
            if (ListType.hasOwnProperty(key)) {
                if ($(listingItemsBaseClass + '.' + ListType[key].class).length > 0) {
                    let item = ListType[key];
                    types.push(item);
                }
            }
        }

        return types;
    },

    getSkuComponents (sku) {
        return getSkuCodes(sku);
    },

    getProductGender (product) {
        return getProductGender(product);
    },

    getProductBaseInfo (product) {
        let id = '';
        let color = '';
        let size = '';

        let colorObject = null;

        let promo = 'no_promotion';
        if ('promotions' in product && product.promotions && product.promotions.length > 0) {
            promo = product.promotions.map(function (el) { return el.enabled ? el.id : null; }).filter(function (el) { return el !== null; }).join('-');
        } else if ('appliedPromotions' in product && product.appliedPromotions && product.appliedPromotions.length > 0) {
            promo = product.appliedPromotions.map(function (el) { return el.name; }).join('-');
        }

        if (product.productType === 'variant') {
            let components = getSkuCodes(product.id);
            id = components.id;
            color = components.color;
            size = components.size;

            for (let k in product.variationAttributes) {
                const variationAttribute = product.variationAttributes[k];
                if (variationAttribute.attributeId === 'color') {
                    if ('values' in variationAttribute) {
                        for (let j in variationAttribute.values) {
                            if (variationAttribute.values[j].selected === true) {
                                colorObject = variationAttribute.values[j];
                                break;
                            }
                        }
                    } else {
                        colorObject = variationAttribute;
                    }
                    break;
                }
            }
        } else if (product.productType === 'variationGroup') {
            // in this case the user only chose the color, and not the size
            id = product.id.split('_')[0].trim();
            color = product.id.split('_')[2].trim();

            let selectedVariation;

            for (let k in product.variationAttributes) {
                const variationAttribute = product.variationAttributes[k];
                if (variationAttribute.attributeId === 'color') {
                    for (let j in variationAttribute.values) {
                        if (variationAttribute.values[j].selected === true) {
                            colorObject = variationAttribute.values[j];
                            break;
                        }
                    }
                }
                if (selectedVariation !== undefined) {
                    break;
                }
            }
        }

        return {
            id: id,
            color: color,
            colorObject: colorObject,
            size: size,
            promo: promo
        };
    },

    formatProductForAnalytics (product) {
        product = formatStringProductPropertyIfExists(product, 'item_name');
        product = formatStringProductPropertyIfExists(product, 'item_brand');
        product = formatStringProductPropertyIfExists(product, 'item_list_name');
        product = formatStringProductPropertyIfExists(product, 'item_list_id');
        product = formatStringProductPropertyIfExists(product, 'item_variant', true);
        product = formatFloatProductPropertyIfExists(product, 'price');
        product = formatStringProductPropertyIfExists(product, 'item_category');
        product = formatStringProductPropertyIfExists(product, 'item_category2');
        product = formatStringProductPropertyIfExists(product, 'item_category3');
        product = formatStringProductPropertyIfExists(product, 'item_category4');
        product = formatStringProductPropertyIfExists(product, 'item_category5');
        product = formatIntegerProductPropertyIfExists(product, 'quantity');
        product = formatStringProductPropertyIfExists(product, 'size', true);
        product = formatStringProductSalePropertyIfExists(product, 'item_on_sale');
        product = formatStringProductPropertyIfExists(product, 'item_availability');
        product = formatStringProductPropertyIfExists(product, 'coupon');
        product = formatStringProductPropertyIfExists(product, 'item_color');
        product = formatStringProductPropertyIfExists(product, 'item_sfcc');
        product = formatStringProductPropertyIfExists(product, 'item_customization');
        product = formatStringProductPropertyIfExists(product, 'item_sustainable');
        product = formatFloatProductPropertyIfExists(product, 'discount');
        return product;
    },

    checkPage (str) {
        return window.location.href.toLowerCase().indexOf(str) !== -1;
    },

    // Formatting
    formatString (str) {
        return formatStringForAnalytics(str);
    },

    format4DigitNumber (number) {
        if (number < 0) {
            return '0000';
        } else if (number < 10) {
            return '000' + number;
        } else if (number < 100) {
            return '00' + number;
        } else if (number < 1000) {
            return '0' + number;
        }
        return number.toString();
    },

    // URL Parameters
    insertParameter (key, value) {
        insertParam(key, value);
    },
    existsParameter (key) {
        return hasParam(key);
    },

    // Push on DataLayer
    push (pushObject, log = true) {
        // eslint-disable-next-line
        dataLayer.push(pushObject);

        if (log && testEnabled) {
            console.info(pushObject);
        }
    },

    log (data, inline = false) {
        if (!testEnabled) {
            return;
        }
        if (inline) {
            console.info('Analytics: ' + data);
        } else {
            console.info('Analytics: ');
            console.info(data);
        }
    },

    getFormatSku (sku) {
        return getFormatSkuForAnalytics(sku);
    },

    getCatalogProductId (sku) {
        return getCatalogProductId(sku);
    },

    formatNameForAnalytics (name) {
        if (!name) {
            return '';
        }
        let formattedPlus = name.toLowerCase().replace(/[+]/g, '_plus_');
        let formattedName = formattedPlus.replace(/\W/g, '_');
        let analyticsName = formattedName.split('_').filter((el) => { return el; }).join('_');
        return analyticsName;
    },

    formatSkus (skus) {
        let formattedSkus = '';
        for (let i = 0; i < skus.length; i++) {
            let formattedSku = getFormatSkuForAnalytics(skus[i]).replace(/\W/g, '_');
            if (i === 0) {
                formattedSkus += formattedSku;
            } else {
                formattedSkus += '-' + formattedSku;
            }
        }
        return formattedSkus;
    },

    getProductNameEngFromPdp () {
        let nameEng = $('.analytics.product').data('name');
        return nameEng;
    },

    getFormatedNewsletterPreferenceBrands (list) {
        let brandsStr = '';
        for (let brand of list) {
            brandsStr += brandsMapping[brand] + '-';
        }

        brandsStr = brandsStr.substring(0, brandsStr.length - 1);

        return brandsStr;
    },

    getListId (container, provider) {
        let list = '';
        if (container && $(container).parents('.analytics-mini-cart').length > 0) {
            list = 'minicart';
        } else if ($(container).parents('.js-site-search-suggestions-products').length > 0) { // Search results
            list = 'plp';
        } else if ($('.page[data-action="Product-Show"]').length > 0) {
            list = 'pdp';
        } else if ($('.page[data-action="Search-Show"]').length > 0) {
            list = $('.page.js-page-home-gender').length > 0 ? 'home' : 'plp';
        } else if ($('.page[data-action="Cart-Show"]').length > 0 || $('.page[data-action="Checkout-Begin"]').length > 0) {
            list = 'cart';
        } else if ($('.page[data-action="Wishlist-Show"]').length > 0) {
            list = 'wishlist';
        } else if ($('.page[data-action="OrderAgain-ShowAccount"]').length > 0 || $('.page[data-action="Order-History"]').length > 0 || $('.page[data-action="Order-Details"]').length > 0) {
            list = 'my_orders_and_returns';
        } else if ($('.page[data-action="OrderAgain-ShowCart"]')) {
            list = 'shopping_bag';
        }

        if (list && provider && (list === 'pdp' || list === 'home' || list === 'cart')) {
            list = `${provider}_${list}`;
        }

        return list;
    },

    getProductList () {
        let items = [];
        let container = $('.analytics.checkout.checkout-product');

        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();

            // Fix values for MEC-30160
            if (obj.item_list_name === 'not_available') {
                obj.item_list_name = 'listing'
            }
    
            if (obj.item_list_id === 'not_available') {
                obj.item_list_id = 'pdp'
            }

            if (obj.id !== 'PERS_PROD') {
                obj['quantity'] = obj.quantity;
                obj['index'] = i;
                items.push(this.formatProductForAnalytics(obj));
            }
        }
        return items;
    },

    getGrandTotal () {
        return $('.analytics-totals').data('grand-total');
    },

    getAppliedCoupon () {
        const coupon = [];
        $('#couponCode.coupon-code-field--applied').val() && coupon.push($('#couponCode.coupon-code-field--applied').val());
        $('.analytics-shipping-discount').length && coupon.push('shipping_discount');
        $('.analytics-order-discount').length && coupon.push('order_discount');
        return coupon.join(',');
    },

    getUpsellingMessage () {
        let upsellingMessage = 'no_message';
        const vals = [];
        $('.analytics-message').each(function () {
            if (vals.indexOf($(this).data('analytics-type')) === -1) {
                vals.push($(this).data('analytics-type'));
            }
        });
        if (vals.length > 0) {
            upsellingMessage = vals.join('-');
        }
        localStorage.setItem('upsellingMessage', upsellingMessage);
        return upsellingMessage;
    },

    getBeginCheckoutData (context) {
        return {
            upselling_message: this.getUpsellingMessage(),
            currency: context.helperData.currency,
            value: this.getGrandTotal(),
            coupon: this.getAppliedCoupon(),
            items: this.getProductList()
        };
    },

    getTypeOfAccount () {
        let typeOfAccount = 'only_registration';
        if ($('.loyalty-flag:checked').length === 1) {
            typeOfAccount = 'profile_loyalty';
        }
        return typeOfAccount;
    },
    storeGtmData (data) {
        if (data && data.item_list_name && data.item_list_id && (data.index || data.index === 0)) {
            if (data.item_id && data.item_variant) {
                window.sessionStorage.setItem('GTM_' + data.item_id + '_color_' + data.item_variant, JSON.stringify({'item_list_name': data.item_list_name, 'item_list_id': data.item_list_id, 'index': data.index}));
            }
            // Adding values for color change event
            window.sessionStorage.setItem('GTM_item_list_name', data.item_list_name);
            window.sessionStorage.setItem('GTM_item_list_id', data.item_list_id);
            window.sessionStorage.setItem('GTM_index', data.index);
        }
    },
    getGtmData (data) {
        const GTMData = {};
        if (data && data.item_id && data.item_variant) {
            const GTMItem = JSON.parse(window.sessionStorage.getItem('GTM_' + data.item_id + '_color_' + data.item_variant)) || {};
            GTMData.item_list_name = stringOrNotAvailable(GTMItem.item_list_name);
            GTMData.item_list_id = stringOrNotAvailable(GTMItem.item_list_id);
            GTMData.index = numberOrZero(GTMItem.index);
        } else {
            GTMData.item_list_name = getStringAnalyticsValueFromStorage('GTM_item_list_name');
            GTMData.item_list_id = getStringAnalyticsValueFromStorage('GTM_item_list_id');
            GTMData.index = getNumberAnalyticsValueFromStorage('GTM_index');
        }
        return GTMData;
    },
    setBonusProductData ($container, index) {
        $container.data('item_list_name', 'free_product');
        $container.data('item_list_id', this.getListId());
        $container.data('index', index);
        $container.data('discount', $container.data('price'));
        $container.data('price', 0);
    },
    findEventItemListValues (products) {
        var itemListName = '';
        var itemListId = '';
        if (products && !('length' in products)) {
            products = [products];
        }
        if (products && products.length === 1) {
            itemListId = products[0].item_list_id;
            itemListName = products[0].item_list_name;
        }
        return {itemListName, itemListId};
    }
};
